<div class="configurable-panel w-100">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h6>{{ title }}</h6>
    <div class="btn-config-box" >
      <input type="file" #fileInput style="display: none" (change)="onSelect($event)" accept=".pdf,.jpg,.jpeg,.png"/>
      <button class="btn btn-sm btn-config rounded-1" (click)="fileInput.click()">
        <i class="bi bi-upload"></i> Scan
      </button>
    </div>
  </div>
  <ng-content></ng-content>
</div>
